export default "__VITE_ASSET__oh7xSe9X__"